import React, { useRef } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography,
  Button,
  Grid,
} from '@mui/material';
import { useStyles } from './style';
import { TableComponents, Icons } from 'components';
import useCustomHook from '../../hooks';
import { useCopy, useCurrencyUnit } from 'hooks';
import { Alert } from '@mui/material';
import LoanServices from '../../services/LoanServices';
import { columns, generateData } from './components/Columns';
import { PaymentWithCreditDialog } from './components';
import { PerSettlementDialog } from '../components';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';

export default function LoanInstallmentDialog({ open, setOpen, loan  }) {
  const classes = useStyles();
  const { copyItem } = useCopy();
  const currencyText = useCurrencyUnit();

  /**
   * لیست اکشن ها رو برمیگرداند . به ازای هر اکشن ، درصورتیکه دسترسی داشته باشد ترو و دسترسی نداشته باشد فالز است
   */
  const actionsList = getDynamicObjectAction(['loanPayPayAction', 'loanPayPaySoonerAction']);
  const dialogTableRef = useRef();
  const {
    loading,
    setLoading,
    perSettlementOpen,
    setPerSettlementOpen,
    paymentWithCreditOpen,
    setPaymentWithCreditOpen,
    size,
    setSize,
    page,
    setPage,
    selectedInstallment,
    setSelectedInstallment,
  } = useCustomHook();

  const getLoanInstallmentList = async (query) => {
    setLoading(true);
    try {
      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query?.pageSize || size,
        loanId: loan.id,
      };
      const res = await LoanServices.getUserInstallmentList(params);

      let list = [];
      if (res?.result) {
        list = generateData(res?.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }
      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      setLoading(false);
      return d;
    } catch (e) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const ActionBtn = ({ rd }) => {
    return (
      <Button
        disabled={rd.status != 'INSTALLMENT_STATUS_CREATED'}
        startIcon={<Icons icon="Banking" color="#939393" size="20" />}
        variant="contained"
        className={classes.expandBtn}
        onClick={() => {
          setPaymentWithCreditOpen(true);
          setSelectedInstallment(rd);
        }}
      >
        پرداخت
      </Button>
    );
  };

  return (
    <>
      <Dialog
        onClose={() => setOpen(false)}
        aria-labelledby="simple-dialog-title"
        fullWidth
        maxWidth="md"
        className={classes.dialogMain}
        open={open}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setOpen(false)}
          className={classes.title}
        >
          لیست اقساط
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => setOpen(false)}
          >
            <Icons icon="Close" color="#939393" size="20" />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <Alert
            severity="info"
            icon={null}
            className={classes.alert}
            style={{ alignItems: 'center', marginBottom: '1em' }}
          >
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              width="100%"
              style={{ width: '100%' }}
            >
              <Grid item md={10} xs={12}>
                <Typography>
                  شناسه واریز: {loan.paymentNumber ?? 'بدون شناسه واریز'}{' '}
                  {loan.paymentNumber && (
                    <IconButton onClick={() => copyItem(loan.paymentNumber)} size="large">
                      <Icons icon="copy" color="#d1d8dc" hover="#303d8f" size="20" />
                    </IconButton>
                  )}
                </Typography>
              </Grid>
              {actionsList['loanPayPaySoonerAction'] && (
                <Grid item md={2} xs={12} container justifyContent="flex-end">
                  <Button
                    onClick={() => setPerSettlementOpen(true)}
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={loan.statusCode !== 'LOAN_STATUS_CREATED'}
                  >
                    تسویه زودتر از موعد
                  </Button>
                </Grid>
              )}
            </Grid>
          </Alert>
          {currencyText && (
            <TableComponents
              data={getLoanInstallmentList}
              columns={columns(actionsList, ActionBtn, currencyText)}
              isLoading={loading}
              ref={dialogTableRef}
              onChange={(ps) => {
                setPage(ps?.pageNumber);
                setSize(ps?.pageSize);
                return getLoanInstallmentList(ps);
              }}
            />
          )}
        </DialogContent>
        <PaymentWithCreditDialog
          open={paymentWithCreditOpen}
          setOpen={setPaymentWithCreditOpen}
          installment={selectedInstallment}
        />
        <PerSettlementDialog
          open={perSettlementOpen}
          setOpen={setPerSettlementOpen}
          loan={loan}
          tableRef={dialogTableRef}
        />
      </Dialog>
    </>
  );
}
